import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import 'dayjs/locale/ko';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AdminRoutes, StaffRoutes, UserRoutes } from 'app-routes';
import theme from '../theme';
import './app.module.scss';
import { isAdmin, isStaff, isUser } from '@utils/getRole';
import { AuthProvider } from 'contexts/authContext';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme()}>
        <ToastContainer
          toastStyle={{
            backgroundColor: 'white',
          }}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
          {/* <AuthProvider> */}
          {isAdmin && (
            <AuthProvider>
              <RouterProvider router={AdminRoutes} />
            </AuthProvider>
          )}
          {isStaff && (
            <AuthProvider>
              <RouterProvider router={StaffRoutes} />
            </AuthProvider>
          )}
          {/* </AuthProvider> */}
          {isUser && <RouterProvider router={UserRoutes} />}
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
